import styled from 'styled-components';

export const AudienceTargetingGroupListStyled = styled.div`
  width: 40%;
  border-radius: 8px;
  background: var(--color-sonata-primary-200);
  padding: var(--spacing-16);
  .audienceTargetingGroupList {
    &__boxHeader {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: var(--spacing-10);

      &--title {
        color: var(--color-sonata-primary-800);
        font: var(--font-body-500-bold);
      }
    }

    &__emptyState {
      .emptyState {
        background-color: ${props => props.theme.uiColors.background01};
      }
    }

    &__boxContainer {
      display: flex;
      flex-direction: column;
    }
  }
`;
